import api from "@api"
import { useStore } from "@stores"
import { useAppContext } from "@components/AppContext"

const indexOperation = api.get("transactions/ListMyCustomerBeneficialOwners")


const useBeneficialOwnersStore = customerId => {
  const { authenticatedRequest } = useAppContext()

  const dependencies = [ customerId ]
  const shouldAutoLoad = false
  const indexParameters = { customerId }

  const {
    items: beneficialOwners,
    indexItems: indexBeneficialOwners,
  } = useStore(indexOperation.id, authenticatedRequest, shouldAutoLoad, indexParameters, dependencies)

  return {
    beneficialOwners,
    indexBeneficialOwners,
  }
}

export default useBeneficialOwnersStore
